import { render, staticRenderFns } from "./axsr-login.vue?vue&type=template&id=0ff39b0e&"
import script from "./axsr-login.vue?vue&type=script&lang=js&"
export * from "./axsr-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports